import { styled } from "@mui/material";

export const StyledCustomerAccessRevokedMessage = styled("section")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "calc(100vh - 80px)",
  padding: "48px 24px",
  textAlign: "center",
});

export const StyledCustomerAccessRevokedTitle = styled("h2")({
  color: "#664d03",
  fontSize: "1.5rem",
  fontWeight: 600,
  marginBottom: 16,
});

export const StyledCustomerAccessRevokedText = styled("p")({
  color: "#344767",
  fontSize: "1rem",
  maxWidth: 560,
  marginBottom: 12,
  lineHeight: 1.5,
});

export const StyledCustomerAccessRevokedHint = styled("p")({
  color: "#67748e",
  fontSize: "0.875rem",
  maxWidth: 560,
  marginBottom: 0,
  lineHeight: 1.5,
});
